import { Injectable } from '@angular/core';
import { AngularCsv } from 'angular7-csv/dist/Angular-csv';

@Injectable({
  providedIn: 'root'
})
export class DownloadAsCsvService {

  constructor() { }

  downloadcsvFile(data, fileName= 'SignInReport') {
    if (data !== null){
    const options = {
      fieldSeparator: ',',
      quoteStrings: '"',
      decimalseparator: '.',
      showLabels: true,
      showTitle: false,
      useBom: true,
      headers: Object.keys(data[0])
    };

    // tslint:disable-next-line: no-unused-expression
    new AngularCsv(data, fileName, options);
  }
}
}
